/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { PrimaryButton } from 'src/components/Button'
import FlexBox from 'src/components/Common/FlexBox'
import Icon from 'src/components/Icon'
import { useThemeContext } from 'src/contexts/ThemeContext'
import DonationHistory from 'src/features/donation/donation-history'
import { useModalV2Context } from 'src/features/modal-v2'

const DonationHistoryButton = () => {
  const { openModal } = useModalV2Context()
  const { colors } = useThemeContext()

  return (
    <PrimaryButton
      outlined
      size="small"
      onClick={() => {
        openModal(
          {
            content: <DonationHistory />,
            dialogTitle: 'View your donation history'
          },
          'donation-history'
        )
      }}
    >
      <FlexBox as="span" alignItems="center" columnGap={8}>
        <Icon color={colors.primary} icon="history" size={22} />
        Donation History
      </FlexBox>
    </PrimaryButton>
  )
}

export default DonationHistoryButton
